import { Box } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { customValue } from "../../utils/colorVariable";

export const RegisterLeftContent = () => {
  // Array of image URLs for the slider
  const images = [
    `${process.env.PUBLIC_URL}/image/slide-img1.jpg`,
    `${process.env.PUBLIC_URL}/image/slide-img2.jpg`, // Add more images as needed
    `${process.env.PUBLIC_URL}/image/slide-img3.jpg`,
    `${process.env.PUBLIC_URL}/image/slide-img4.jpg`,
    `${process.env.PUBLIC_URL}/image/slide-img5.jpg`,
  ];

  return (
    <Box width={"50%"} display={{ xs: "none", sm: "block" }}>
      {/* Logo */}
      <img
        src={`${process.env.PUBLIC_URL}/accord_knits.png`}
        alt="Logo"
        style={{
          position: "absolute",
          height: 100,
          borderBottomRightRadius: customValue.borderRadius,
          zIndex: 2,
        }}
      />

      {/* Swiper Slider */}
      <Swiper
        style={{
          height: "80vh",
          width: "100%",
          borderBottomLeftRadius: customValue.borderRadius,
        }}
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        loop={true}
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <img
              src={image}
              alt={`Slide ${index + 1}`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};
